import * as React from "react";
import {useEffect} from "react";
import {RouteComponentProps} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {getRoutes, setIndexPath} from "egold/routes";
import "./styles.scss";
import Loading from "components/loading";
import {getBalance, getUser, hideToast} from "egold/actions";
import {vendor} from "egold/egold-config";
import {IEgoldUserDetails} from "StateInterface";
import Toast from "components/toast";
import {AndroidApis} from "app";

interface IConnectProps {
    androidVersion: number;
    dispatch?: (action: any) => void;
    loading: boolean;
    isAndroid: boolean;
    userId: number;
    eGoldUserDetails: IEgoldUserDetails;
    toastDetails: {
        bgColor: string;
        msg: string;
    };
}

function SafeGold(props: IConnectProps & RouteComponentProps) {
    setIndexPath(props.match.url);
    function handleHideToast() {
        props.dispatch(hideToast());
    }
    useEffect(() => {
        props.dispatch(getUser(props.userId));
        if (props.isAndroid) {
            AndroidApis.clearWebStack();
            AndroidApis.showPopUpOnBack({
                title: "Go Back",
                message: "Are you sure to go back to dashboard ?",
                positiveButtonText: "Yes",
                negativeButtonText: "No",
                enablePopUp: true,
            });
        }
    }, []);
    useEffect(() => {
        if (props.eGoldUserDetails) props.dispatch(getBalance(vendor.SAFEGOLD, props.eGoldUserDetails.vendor_id));
    }, [props.eGoldUserDetails]);
    return (
        <div className={"egold container-fluid d-flex justify-content-center"} style={{maxWidth: "525px"}}>
            <Loading active={props.loading}/>
            <div className={"egold-body w-100"}>
                {getRoutes(props.match.path)}
            </div>
            <Toast hideToast={handleHideToast} toastDetails={props.toastDetails}/>
        </div>
    );
}

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        loading: state.eGold.loading,
        userId: state.login.auth.userId,
        eGoldUserDetails: state.eGold.eGoldUserDetails,
        toastDetails: state.eGold.toastDetails,
        isAndroid: state.login.isAndroid,
        androidVersion: state.login.apiVersion,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(SafeGold);
